import React, { FC, useState } from 'react';
import ReactModal from 'react-modal';

interface EmailModalProps {
  onClose: () => void;
  onSend: (email: string) => void;
  isOpen: boolean;
}

const EmailModal: FC<EmailModalProps> = ({ onClose, onSend, isOpen }) => {
  const [email, setEmail] = useState('');
  const customStyles: ReactModal.Styles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      maxWidth: '60vw',
      transform: 'translate(-50%, -50%)',
      border: 'none',
      backgroundColor: 'transparent'
    },
  };
  return (
    <ReactModal
          isOpen={isOpen}
          style={customStyles}
          shouldCloseOnOverlayClick={true}
          shouldCloseOnEsc={false}
          ariaHideApp={false}
          onRequestClose={onClose}
        >
      <div className="bg-white p-4 rounded shadow-lg">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter email address"
          className="border p-2 mb-2 w-full"
        />
        <div className="flex justify-end gap-2">
        <button onClick={onClose} className="w-[unset] text-sm justify-self-center mt-4 px-3 py-2 cursor-pointer text-black hover:bg-whiteButton-hover font-[300] bg-whiteButton rounded-md shadow-sm">
            Cancel
          </button>
          <button
            onClick={() => {
              onSend(email);
              onClose();
            }}
            className="w-[unset] text-sm justify-self-center mt-4 px-3 py-2 text-white cursor-pointer hover:bg-grayBlue-hover font-[300] bg-grayBlue rounded-md shadow-sm"
          >
            Send
          </button>
        </div>
      </div>
      </ReactModal>
  );
};

export default EmailModal;